module.exports = __webpack_public_path__ + "static/media/menuDir.e8104ce3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/menuDir.svg
// module id = 184
// module chunks = 0